export function validateBC(input: string): boolean {
  const regex = /^[A-Za-z0-9_]{1,30}$/;
  return regex.test(input);
}
